import { useEffect, useState } from "react";
import { FaClipboardList, FaEdit } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import CustomCarousel from "../../../Components/CustomCarousel";
import Editor from "../../../Components/Editor";
import PageHeader from "../../../Components/PageHeader";
import Spin from "../../../Components/Spin";
import api from "../../../Utils/api";
import { updateApplication } from "../../../store/reducer/application";
import { setLoading } from "../../../store/reducer/loading";

const Application = () => {
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [dataApplication, setDataApplication] = useState(null);
  const [update, setUpdate] = useState(false);
  const [description, setDescription] = useState("");

  const { id } = useParams();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDataApplication((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const application = { ...dataApplication, description };

    try {
      setIsLoading(true);
      const { data } = await api.put(
        `application/${application.id}`,
        application
      );
      if (!data.application) {
        toast.error("Vérifier vos données avant la soumission.");
        return;
      }
      toast.success("Mise à jour éffectuée.");
      dispatch(updateApplication(data));
      setUpdate(false);
    } catch (error) {
      if (error.response.status === 401) {
        navigate("/login");
      }
    } finally {
      setIsLoading(false);
    }
  };

  document.title = "DashBoard | Application";

  useEffect(() => {
    if (id) {
      const loadApplication = async (id) => {
        dispatch(setLoading(true));

        try {
          const { data } = await api.get(`application/${id}`);

          const { application, images, telechargements } = data;

          if (!application || !images) {
            toast.error("Cette application n'existe pas !");
            navigate("/applications");
          }

          const app = {
            id: application.id,
            labelle: application.labelle,
            nbrTelechargement: telechargements.length,
            lien: application.lien,
            actif: application.actif,
            createdAt: application.createdAt,
            images: images,
          };

          setDataApplication(app);
          setDescription(application.description);
        } catch (error) {
          if (error.response.status === 401) {
            navigate("/login");
          }
          if (error.response.status === 500 || error.response.status === 404) {
            toast.info(
              "L'application que vous venez de sélectionner n'existe pas!"
            );
            navigate("/applications");
          }
        } finally {
          dispatch(setLoading(false));
        }
      };
      loadApplication(id);
    }
  }, [id]);

  return (
    <>
      <PageHeader page="Détails Application" />

      {/* Main content */}
      <section className="content">
        <div className="container-fluid">
          <div className="card">
            <div className="card-header">
              <div
                className="card-tools"
                style={{
                  marginBottom: "-2%",
                }}
              >
                <p
                  className="mr-3"
                  style={{
                    color: "#ccc",
                    cursor: "pointer",
                    fontSize: "1.6rem",
                  }}
                  onClick={() => setUpdate(!update)}
                >
                  <p
                    style={{
                      color: "#1d75f0",
                    }}
                  >
                    {update ? <FaClipboardList /> : <FaEdit />}
                  </p>
                </p>
              </div>
            </div>
            <div className="card-body">
              {dataApplication && (
                <form className="form-horizontal" onSubmit={handleSubmit}>
                  {!update && (
                    <div className="form-group row">
                      <label htmlFor="lbl" className="col-sm-2 col-form-label">
                        Image
                      </label>
                      <div className="col-sm-10">
                        <CustomCarousel slides={dataApplication.images} />
                      </div>
                    </div>
                  )}

                  <div className="form-group row">
                    <label htmlFor="lbl" className="col-sm-2 col-form-label">
                      Libéllé
                    </label>
                    <div className="col-sm-10">
                      <input
                        type="text"
                        name="labelle"
                        className="form-control"
                        id="lbl"
                        placeholder="Libéllé"
                        disabled={!update}
                        onChange={handleChange}
                        value={dataApplication.labelle}
                        // defaultValue={application.labelle}
                      />
                    </div>
                  </div>
                  {!update && (
                    <div className="form-group row">
                      <label htmlFor="link" className="col-sm-2 col-form-label">
                        Exécutable de l'application
                      </label>
                      <div className="col-sm-10">
                        <input
                          type="text"
                          className="form-control"
                          id="link"
                          name="lien"
                          onChange={handleChange}
                          disabled={!update}
                          placeholder="lien de téléchargement"
                          value={dataApplication.lien}
                          // defaultValue={application.lien}
                        />
                      </div>
                    </div>
                  )}
                  <div className="form-group row">
                    <label htmlFor="desc" className="col-sm-2 col-form-label">
                      Description
                    </label>
                    <div className="col-sm-10">
                      <Editor
                        value={description}
                        onChange={setDescription}
                        readOnly={!update}
                      />
                    </div>
                  </div>
                  {!update && (
                    <div className="form-group row">
                      <label
                        htmlFor="nbrTelechargement"
                        className="col-sm-2 col-form-label"
                      >
                        Nombre de téléchargement
                      </label>
                      <div className="col-sm-10">
                        <input
                          type="number"
                          className="form-control"
                          id="nbrTelechargement"
                          // name="nbrTelechargement"
                          placeholder="Nombre de téléchargement"
                          defaultValue={
                            dataApplication.nbrTelechargement === null
                              ? "0"
                              : dataApplication.nbrTelechargement
                          }
                          disabled
                        />
                      </div>
                    </div>
                  )}

                  <div className="form-group row">
                    <label htmlFor="status" className="col-sm-2 col-form-label">
                      Status
                    </label>
                    <div className="col-sm-10">
                      <select
                        className="custom-select form-control-border"
                        id="status"
                        onChange={handleChange}
                        value={dataApplication.actif}
                        name="actif"
                        disabled={!update}
                        // defaultValue={application.actif}
                      >
                        <option>Choisir un status</option>
                        <option value="true">Activé</option>
                        <option value="false">Désactivé</option>
                      </select>
                    </div>
                  </div>
                  {update ? (
                    <div className="form-group row">
                      <div className="offset-sm-2 col-sm-10">
                        <button
                          type="submit"
                          className="btn btn-info"
                          disabled={isLoading}
                        >
                          {isLoading ? <Spin size="sm" /> : "Metre à jour"}
                        </button>
                      </div>
                    </div>
                  ) : (
                    <div className="form-group row">
                      <div className="offset-sm-2 col-sm-10">
                        <button
                          type="submit"
                          className="btn btn-info"
                          onClick={() => navigate("/applications")}
                        >
                          Retour
                        </button>
                      </div>
                    </div>
                  )}
                </form>
              )}
            </div>
          </div>
        </div>
      </section>
      {/* /.content */}
    </>
  );
};

export default Application;
